import { breakpoints, PageBlock, Stack, vars } from '@etg/wings';
import { DangerousHtmlContent, ProgressSpinner } from '@eti/components';
import { useProperty, useSearch, useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { useMediaQuery } from 'usehooks-ts';
import { getDestinationCode } from '../../../utils/format';
import MetaToBrandLoader from './meta-to-brand-loader/MetaToBrandLoader';
import TripDetails from './SearchTransitionTripDetails';

const spinnerBlockStyles = css`
  align-content: center;
  height: 100%;
`;

const publishedContentBlockStyles = css`
  background-color: ${vars.colors.page.background.primary};
  margin-top: auto;
`;

const SearchTransition = () => {
  const { t } = useTranslation();
  const { p } = useProperty();
  const { currentSearchData } = useSearch();
  const isWiderViewport = useMediaQuery(`(min-width: ${breakpoints._768})`);

  const publishedContent = t('Air.Search.PublishContent');

  return (
    <>
      {p('Result.MetaToBrandLoader.Enabled') ? (
        <MetaToBrandLoader />
      ) : (
        <PageBlock className={spinnerBlockStyles} withPaddingY>
          <Stack data-testid="resultPage-searchTransition-progressIndicator" spacing={16}>
            <ProgressSpinner
              destinationIataCode={getDestinationCode(currentSearchData?.routes)}
              duration="6s"
              size={isWiderViewport ? 300 : 220}
            />
            <TripDetails />
          </Stack>
        </PageBlock>
      )}
      {publishedContent && (
        <PageBlock
          className={publishedContentBlockStyles}
          data-testid="resultPage-searchTransition-publishedContent"
          withPaddingY
        >
          <DangerousHtmlContent content={publishedContent} />
        </PageBlock>
      )}
    </>
  );
};

export default SearchTransition;
